import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import { DEFAULT_TIMEOUT } from '../lib/constants';

var Push = /*#__PURE__*/function () {
  /**
   * Initializes the Push
   *
   * @param channel The Channel
   * @param event The event, for example `"phx_join"`
   * @param payload The payload, for example `{user_id: 123}`
   * @param timeout The push timeout in milliseconds
   */
  function Push(channel, event) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_TIMEOUT;

    _classCallCheck(this, Push);

    this.channel = channel;
    this.event = event;
    this.payload = payload;
    this.timeout = timeout;
    this.sent = false;
    this.timeoutTimer = undefined;
    this.ref = '';
    this.receivedResp = null;
    this.recHooks = [];
    this.refEvent = null;
  }

  _createClass(Push, [{
    key: "resend",
    value: function resend(timeout) {
      this.timeout = timeout;

      this._cancelRefEvent();

      this.ref = '';
      this.refEvent = null;
      this.receivedResp = null;
      this.sent = false;
      this.send();
    }
  }, {
    key: "send",
    value: function send() {
      if (this._hasReceived('timeout')) {
        return;
      }

      this.startTimeout();
      this.sent = true;
      this.channel.socket.push({
        topic: this.channel.topic,
        event: this.event,
        payload: this.payload,
        ref: this.ref
      });
    }
  }, {
    key: "receive",
    value: function receive(status, callback) {
      var _a;

      if (this._hasReceived(status)) {
        callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
      }

      this.recHooks.push({
        status: status,
        callback: callback
      });
      return this;
    }
  }, {
    key: "startTimeout",
    value: function startTimeout() {
      var _this = this;

      if (this.timeoutTimer) {
        return;
      }

      this.ref = this.channel.socket.makeRef();
      this.refEvent = this.channel.replyEventName(this.ref);
      this.channel.on(this.refEvent, function (payload) {
        _this._cancelRefEvent();

        _this._cancelTimeout();

        _this.receivedResp = payload;

        _this._matchReceive(payload);
      });
      this.timeoutTimer = setTimeout(function () {
        _this.trigger('timeout', {});
      }, this.timeout);
    }
  }, {
    key: "trigger",
    value: function trigger(status, response) {
      if (this.refEvent) this.channel.trigger(this.refEvent, {
        status: status,
        response: response
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._cancelRefEvent();

      this._cancelTimeout();
    }
  }, {
    key: "_cancelRefEvent",
    value: function _cancelRefEvent() {
      if (!this.refEvent) {
        return;
      }

      this.channel.off(this.refEvent);
    }
  }, {
    key: "_cancelTimeout",
    value: function _cancelTimeout() {
      clearTimeout(this.timeoutTimer);
      this.timeoutTimer = undefined;
    }
  }, {
    key: "_matchReceive",
    value: function _matchReceive(_ref) {
      var status = _ref.status,
          response = _ref.response;
      this.recHooks.filter(function (h) {
        return h.status === status;
      }).forEach(function (h) {
        return h.callback(response);
      });
    }
  }, {
    key: "_hasReceived",
    value: function _hasReceived(status) {
      return this.receivedResp && this.receivedResp.status === status;
    }
  }]);

  return Push;
}();

export { Push as default };